// ! oq-saroy
import oqsaroy1 from "../../photos/uzb_shahr_oqsaroy1.webp";
import oqsaroy2 from "../../photos/uzb_shahr_oqsaroy2.webp";
import oqsaroy3 from "../../photos/uzb_shahr_oqsaroy3.webp";

// ! dorut tilovat
import dorut1 from "../../photos/uzb_shahr_dorut1.webp";
import dorut2 from "../../photos/uzb_shahr_dorut2.webp";
import dorut3 from "../../photos/uzb_shahr_dorut3.webp";

// ! dorus saodat
import dorus1 from "../../photos/uzb_shahr_dorus1.webp";
import dorus2 from "../../photos/uzb_shahr_dorus2.webp";
import dorus3 from "../../photos/uzb_shahr_dorus3.webp";

// ! ko'k gumbaz masjidi
import kokgumbaz1 from "../../photos/uzb_shahr_kokgumbaz1.webp";
import kokgumbaz2 from "../../photos/uzb_shahr_kokgumbaz2.webp";
import kokgumbaz3 from "../../photos/uzb_shahr_kokgumbaz3.webp";

// ! chorsu gumbazi
import chorsu1 from "../../photos/uzb_shahr_chorsu1.webp";
import chorsu2 from "../../photos/uzb_shahr_chorsu2.webp";
import chorsu3 from "../../photos/uzb_shahr_chorsu3.webp";

// ! amir temur haykali va muzeyi
import temur1 from "../../photos/uzb_shahr_temur1.webp";
import temur2 from "../../photos/uzb_shahr_temur2.webp";
import temur3 from "../../photos/uzb_shahr_temur3.webp";

const shahrisabz = {
    uz: {
        key: "shahrisabz",
        title: "Shahrisabz — Amir Temurning tug‘ilgan shahri",

        intro: `
Shahrisabz — Qashqadaryo vodiysida joylashgan qadimiy shahar bo‘lib, 2700 yildan ortiq tarixga ega.
Bu shahar Amir Temurning tug‘ilgan joyi sifatida mashhur bo‘lib, “Yashil shahar” ma’nosini anglatadi.
  `,

        history: `
Shahrisabz — Markaziy Osiyoning eng qadimiy shaharlaridan biri bo‘lib, tarixi miloddan avvalgi davrlarga borib taqaladi. Qadimda bu shahar Kesh nomi bilan tanilgan va Sug‘diyona hududining muhim markazlaridan biri hisoblangan.

Shahar nomi forscha “Shahri sabz” — “Yashil shahar” degan ma’noni anglatadi, chunki u serhosil vodiyda joylashgan bo‘lib, bog‘lar va yashillikka boy bo‘lgan.

Shahrisabzning jahon tarixidagi eng muhim o‘rni Amir Temur (1336–1405) bilan bog‘liq. Buyuk sarkarda aynan shu shaharda tug‘ilgan va yoshligini shu yerda o‘tkazgan. Shu sababli Temur o‘z hukmronligi davrida Shahrisabzni alohida e’zozlab, uni Samarqand bilan bir qatorda saltanatning ma’naviy poytaxtiga aylantirmoqchi bo‘lgan.

Amir Temur davrida shaharda ulkan qurilish ishlari olib borilgan — Oq-Saroy, Dorus Saodat va Dorut Tilovat kabi ulkan majmualar aynan shu davrda bunyod etilgan. Bu inshootlar o‘z ulug‘vorligi bilan hatto Samarqanddagi obidalardan ham katta bo‘lgan.

Keyingi asrlarda shahar turli hukmdorlar qo‘l ostida bo‘lgan, ba’zi obidalar vayron bo‘lgan, ammo saqlanib qolgan qismlari hanuzgacha Temuriylar davri me’morchiligining buyukligidan dalolat beradi.

Bugungi kunda Shahrisabz tarixiy markazi UNESCO Jahon merosi ro‘yxatiga kiritilgan bo‘lib, O‘zbekistonning eng muhim tarixiy-madaniy shaharlaridan biri hisoblanadi.
`,
        sections: [
            {
                title: "Oq-Saroy — Shahrisabz",

                content: `
Oq-Saroy Amir Temurning qish qароrgohi sifatida qurilgan bo‘lib, o‘z davrining eng ulkan va hashamatli saroylaridan biri hisoblangan.

Bu inshoot Temuriylar imperiyasining qudrati va boyligini namoyish etish uchun qurilgan bo‘lib, uning peshtoqi hozirgacha o‘zining ulkanligi bilan hайratlantiradi.

Bugungi kunda saroydan faqat ulkan peshtoq qoldiqlari saqlanib qolgan bo‘lsa-da, u hamon Shahrisabzning eng ta’sirchan yodgorligi hisoblanadi.
    `,

                details: `
Oq-Saroy qurilishi 1380-yilda boshlangan va taxminan 24 yil davom etgan. Uning qurilishida Хоrazm, Eron va Hindistondan olib kelingan eng mohir me’morlar ishtirok etgan.

📌 Arxitektura xususiyatlari:
- Asl holida peshtoq balandligi 50 metrdan oshgan
- Devorlarda moviy, oq va oltin ranglardagi koshinlar ishlatilgan
- Peshtoqda geometrik va islimiy naqshlar mavjud bo‘lgan
- Saroy ichida ulkan hovlilar va qabul zallari joylashgan bo‘lgan

📌 Tarixiy ahamiyati:
- Amir Temur bu yerda chet el elchilarini qabul qilgan
- Ispan elchisi Rui Gonsales de Klavixo o‘z sayohatnomasida saroyni tasvirlab o‘tgan
- Saroy Temuriylar qudratining ramzi bo‘lgan

📌 Bugungi holati:
Vaqt o‘tishi va turli bosqinlar natijasida saroyning katta qismi vayron bo‘lgan. Faqat ulkan kirish peshtoqining ikki minorasi saqlanib qolgan, ammo ular hamon o‘z ulug‘vorligini yo‘qotmagan.
    `,

                facts: [
                    "Shahrisabz markazida joylashgan",
                    "1380-yilda qurilishi boshlangan",
                    "Qurilishi taxminan 24 yil davom etgan",
                    "Amir Temurning qish qarorgohi bo‘lgan",
                    "Nomi \"Oq saroy\" — \"oq rangli saroy\" degan ma’noni anglatadi",
                    "Asl peshtoq balandligi 50 metrdan oshgan deb taxmin qilinadi",
                    "Ispan elchisi Klavixo saroyni tasvirlab yozgan",
                    "Faqat kirish peshtoqi qoldiqlari saqlangan",
                    "Moviy va oltin koshinlar bilan bezatilgan",
                    "Xorazm va Eron me’morlari ishtirok etgan",
                    "Temuriylar qudratining ramzi hisoblangan",
                    "Chet el elchilari shu yerda qabul qilingan",
                    "UNESCO Jahon merosi ro‘yxatiga kiritilgan",
                    "Shahrisabzning eng mashhur yodgorligi",
                    "Zilzila va bosqinlar natijasida qisman vayron bo‘lgan",
                    "Ikkita ulkan minora hozirgacha saqlangan",
                    "O‘rta asr me’morchiligining noyob namunasi",
                    "Turistlar uchun eng ko‘p ziyorat qilinadigan joy",
                    "Kechasi yoritilganda ayniqsa ta’sirchan ko‘rinadi",
                    "Shahrisabzning tarixiy ramzi hisoblanadi"
                ],

                images: [oqsaroy1, oqsaroy2, oqsaroy3,]
            },

            {
                title: "Dorut Tilovat majmuasi — Shahrisabz",

                content: `
Dorut Tilovat majmuasi Shahrisabzning eng muhim diniy-tarixiy yodgorliklaridan biri bo‘lib, “ibodat va tilovat maskani” ma’nosini anglatadi.

Bu majmua Amir Temurning ma’naviy ustozlari va yaqinlari sharafiga qurilgan bo‘lib, u Temuriylar davrida shaharning diniy markazi bo‘lgan.

Majmua bir necha maqbara va masjidlardan iborat bo‘lib, o‘zining nafis koshin bezaklari bilan mashhur.
    `,

                details: `
Dorut Tilovat majmuasi XIV asr oxiri — XV asr boshlarida shakllangan bo‘lib, u bir necha inshootlarni o‘z ichiga oladi.

📌 Majmua tarkibi:
- Shamsiddin Kulol maqbarasi — Amir Temurning ma’naviy ustozi sharafiga qurilgan
- Ko‘k Gumbaz masjidi — Ulug‘bek tomonidan qurdirilgan jome masjid
- Gumbazli xonaqoh — ziyoratchilar uchun mo‘ljallangan qism

📌 Tarixiy ahamiyati:
- Shamsiddin Kulol Amir Temurning ruhiy murabbiylaridan biri bo‘lgan
- Majmua Temuriylar oilasi uchun muqaddas ziyoratgoh bo‘lgan
- Bu yerda diniy ta’lim va tilovat marosimlari o‘tkazilgan

📌 Arxitektura:
- Moviy va firuza rangli koshinlar
- Nafis geometrik naqshlar
- Yozuvlar bilan bezatilgan peshtoqlar
- Gumbazlar ustida yulduzsimon naqshlar

Majmua asrlar davomida qayta ta’mirlangan bo‘lib, bugungi kunda ham diniy ziyoratgoh sifatida faoliyat yuritadi.
    `,

                facts: [
                    "Shahrisabz shahrida joylashgan",
                    "\"Dorut Tilovat\" — \"tilovat maskani\" degan ma’noni anglatadi",
                    "XIV–XV asrlarda shakllangan",
                    "Shamsiddin Kulol maqbarasini o‘z ichiga oladi",
                    "Ko‘k Gumbaz masjidi ham shu majmuaga kiradi",
                    "Amir Temurning ma’naviy ustozi shu yerda dafn etilgan",
                    "Temuriylar oilasining muqaddas ziyoratgohi bo‘lgan",
                    "Moviy va firuza koshinlar bilan bezatilgan",
                    "Geometrik va islimiy naqshlar mavjud",
                    "Ulug‘bek davrida qayta qurilgan",
                    "Diniy ta’lim markazi bo‘lgan",
                    "Bugungi kunda ham faol ziyoratgoh",
                    "UNESCO meros hududida joylashgan",
                    "Shahrisabzning muhim diniy yodgorligi",
                    "Peshtoqlarda Qur’on oyatlari yozilgan",
                    "Gumbazlar yulduzsimon naqshlar bilan bezatilgan",
                    "Asrlar davomida bir necha marta ta’mirlangan",
                    "Mahalliy aholi uchun muqaddas hisoblanadi",
                    "Sayyohlar orasida mashhur maskan",
                    "Temuriylar davri diniy me’morchiligining namunasi"
                ],

                images: [dorut1, dorut2, dorut3,]
            },

            {
                title: "Dorus Saodat majmuasi — Shahrisabz",

                content: `
Dorus Saodat majmuasi Shahrisabzning eng muhim maqbaralar kompleksi bo‘lib, “saodat maskani” ma’nosini anglatadi.

Bu majmua Amir Temur tomonidan o‘g‘li Jahongir vafotidan so‘ng, oilaviy maqbara sifatida qurdirilgan. Ba’zi tarixiy ma’lumotlarga ko‘ra, Temur o‘zi uchun ham shu yerda maqbara qurdirmoqchi bo‘lgan.

Majmua o‘zining ulkan gumbazi va nafis koshin bezaklari bilan Temuriylar davri me’morchiligining muhim namunasi hisoblanadi.
    `,

                details: `
Dorus Saodat majmuasi 1370–1380-yillar atrofida qurila boshlangan.

📌 Tarixiy ma’lumot:
Amir Temurning sevimli o‘g‘li Jahongir yosh vafot etgach, Temur uning sharafiga ushbu majmuani qurdirgan. Keyinchalik bu yerga Temurning boshqa qarindoshlari ham dafn etilgan.

📌 Rivoyatga ko‘ra:
Amir Temur o‘zi uchun ham shu majmuada maxsus qabr tayyorlatgan, biroq keyinchalik Samarqanddagi Gur-e Amirga dafn etilgan.

📌 Arxitektura xususiyatlari:
- Ulkan gumbazli tuzilma
- Yer osti dahmasi (kripta)
- Moviy va oq koshinlar bilan bezatilgan devorlar
- Nafis o‘ymakor marmar detallar

📌 Bugungi holati:
Majmuaning katta qismi vaqt o‘tishi bilan vayron bo‘lgan, biroq yer osti dahmasi va ba’zi qismlari saqlanib qolgan hamda arxeologik tadqiqotlar orqali o‘rganilmoqda.
    `,

                facts: [
                    "Shahrisabz shahrida joylashgan",
                    "\"Dorus Saodat\" — \"saodat maskani\" degan ma’noni anglatadi",
                    "1370–1380-yillarda qurila boshlangan",
                    "Amir Temurning o‘g‘li Jahongir sharafiga qurilgan",
                    "Temuriylar oilaviy maqbarasi bo‘lgan",
                    "Temur o‘zi uchun ham qabr tayyorlatgan degan rivoyat bor",
                    "Yer osti dahmasi (kripta) mavjud",
                    "Moviy va oq koshinlar bilan bezatilgan",
                    "Marmar o‘ymakorlik namunalari saqlangan",
                    "Katta qismi vaqt o‘tishi bilan vayron bo‘lgan",
                    "Arxeologik tadqiqotlar hozir ham davom etmoqda",
                    "Temuriylar davri qabr me’morchiligining namunasi",
                    "Shahrisabzning muhim tarixiy yodgorligi",
                    "UNESCO meros ro‘yxatiga kiritilgan hududda",
                    "Oq-Saroyga yaqin joylashgan",
                    "Ichki bezaklarda geometrik naqshlar bor",
                    "Temuriylar davrida qurilgan eng katta maqbaralardan biri",
                    "Sayyohlar tomonidan tez-tez ziyorat qilinadi",
                    "Tarixchilar uchun muhim ilmiy manba",
                    "Shahar tarixining muhim qatlamini ochib beradi"
                ],

                images: [dorus1, dorus2, dorus3,]
            },

            {
                title: "Ko‘k Gumbaz masjidi — Shahrisabz",

                content: `
Ko‘k Gumbaz masjidi Shahrisabzning eng yirik jome masjidlaridan biri bo‘lib, o‘zining ulkan moviy gumbazi bilan mashhur.

Masjid Ulug‘bek tomonidan qurdirilgan bo‘lib, u Dorut Tilovat majmuasi tarkibiga kiradi va shahar diniy hayotining markazi bo‘lgan.

Bugungi kunda ham masjid faol ibodatxona sifatida xizmat qiladi va mahalliy aholi hamda sayyohlar uchun muhim maskan hisoblanadi.
    `,

                details: `
Ko‘k Gumbaz masjidi 1430-yillarda Mirzo Ulug‘bek buyrug‘i bilan qurilgan.

📌 Arxitektura xususiyatlari:
- Ulkan moviy gumbaz (shu sababli “Ko‘k Gumbaz” deb nomlangan)
- Katta ichki ibodat zali
- Nafis koshin bezaklari
- Peshtoqda geometrik va o‘simliksimon naqshlar

📌 Tarixiy ahamiyati:
- Ulug‘bek davrida ilm va din markazi bo‘lgan
- Jome masjid sifatida minglab namozxonlarni qabul qilgan
- Dorut Tilovat majmuasining markaziy qismi hisoblanadi

📌 Bugungi holati:
Masjid ko‘p marta ta’mirlangan bo‘lib, bugungi kunda ham asl shakliga yaqin holda saqlanib, faol foydalanilmoqda.
    `,

                facts: [
                    "Shahrisabz shahrida, Dorut Tilovat majmuasida joylashgan",
                    "1430-yillarda Ulug‘bek tomonidan qurdirilgan",
                    "Nomi ulkan moviy gumbazidan kelib chiqqan",
                    "Shahar jome masjidi vazifasini bajargan",
                    "Katta ichki ibodat zaliga ega",
                    "Koshin bezaklari nafis geometrik naqshlardan iborat",
                    "Ulug‘bek davri me’morchiligining namunasi",
                    "Bugungi kunda ham faol masjid",
                    "Mahalliy aholi tomonidan muntazam ziyorat qilinadi",
                    "Dorut Tilovat majmuasining markaziy qismi",
                    "Bir necha marta ta’mirlangan",
                    "UNESCO meros hududida joylashgan",
                    "Temuriylar davri diniy arxitekturasining muhim namunasi",
                    "Peshtoqida o‘simliksimon naqshlar mavjud",
                    "Shaharning diniy hayoti markazlaridan biri bo‘lgan",
                    "Sayyohlar tomonidan tez-tez tashrif buyuriladi",
                    "Ichki qismida yozuvli bezaklar saqlangan",
                    "Me’morchilik jihatidan Samarqand masjidlariga o‘xshash",
                    "Shahrisabzning diniy ramzlaridan biri",
                    "Kechasi yoritilganda ayniqsa go‘zal ko‘rinadi"
                ],

                images: [kokgumbaz1, kokgumbaz2, kokgumbaz3,]
            },

            {
                title: "Chorsu gumbazi — Shahrisabz",

                content: `
Chorsu gumbazi Shahrisabzning tarixiy savdo markazi bo‘lib, shahar hayotining iqtisodiy va ijtimoiy yuragi hisoblangan.

Bu inshoot to‘rt yo‘l kesishgan nuqtada qurilgan savdo gumbazi bo‘lib, asrlar davomida hunarmandlar va savdogarlar uchun asosiy maskan bo‘lib xizmat qilgan.

Bugungi kunda Chorsu gumbazi tarixiy bozor sifatida faoliyat yuritib, sayyohlar uchun ham qiziqarli maskanga aylangan.
    `,

                details: `
Chorsu gumbazi shahar markazida, to‘rt asosiy ko‘cha kesishgan joyda qurilgan bo‘lib, “chorsu” so‘zi “to‘rt yo‘l” degan ma’noni anglatadi.

📌 Tarixiy vazifasi:
- Savdo va hunarmandchilik markazi bo‘lgan
- Buyuk Ipak yo‘lining mahalliy tarmog‘i sifatida xizmat qilgan
- Turli mahsulotlar — mato, kulolchilik, metall buyumlar shu yerda sotilgan

📌 Arxitektura:
- Gumbazli yopiq savdo galereyasi
- Shamollatish va yorug‘lik uchun maxsus teshiklar
- Sodda, ammo funksional qurilish uslubi

📌 Bugungi holati:
Chorsu gumbazi bugungi kunda ham an’anaviy bozor sifatida faoliyat yuritadi, u yerda mahalliy hunarmandlar o‘z buyumlarini sotadilar.
    `,

                facts: [
                    "Shahrisabz shahar markazida joylashgan",
                    "\"Chorsu\" so‘zi \"to‘rt yo‘l\" degan ma’noni anglatadi",
                    "To‘rt asosiy ko‘cha kesishgan nuqtada qurilgan",
                    "Tarixiy savdo va hunarmandchilik markazi bo‘lgan",
                    "Buyuk Ipak yo‘li tarmog‘ining bir qismi hisoblangan",
                    "Gumbazli yopiq bozor tuzilishiga ega",
                    "Shamollatish uchun maxsus teshiklari bor",
                    "Bugungi kunda ham faol bozor sifatida ishlaydi",
                    "Mahalliy hunarmandlar mahsulotlarini shu yerda sotadi",
                    "Shaharning ijtimoiy-iqtisodiy hayoti markazi bo‘lgan",
                    "Temuriylar davridan buyon savdo an’analarini saqlab kelmoqda",
                    "Sayyohlar uchun mahalliy hunarmandchilikni ko‘rish imkoniyati",
                    "Oq-Saroy va Dorus Saodatga yaqin joylashgan",
                    "Shahar tarixiy markazining muhim qismi",
                    "Kundalik hayot bilan tarixni bog‘lovchi maskan",
                    "Milliy taomlar va suvenirlar shu yerda topiladi",
                    "Me’morchiligi sodda, lekin amaliy",
                    "UNESCO meros hududiga tegishli qism",
                    "Shahrisabzning jonli tarixiy maskanlaridan biri",
                    "Har kuni mahalliy aholi tomonidan foydalaniladi"
                ],

                images: [chorsu1, chorsu2, chorsu3,]
            },

            {
                title: "Amir Temur haykali va muzeyi — Shahrisabz",

                content: `
Amir Temur haykali va muzeyi Shahrisabzning markaziy maydonida joylashgan bo‘lib, buyuk sarkardaning tug‘ilgan shahriga bag‘ishlangan asosiy yodgorlikdir.

Bu maskan Amir Temur hayoti, faoliyati va Temuriylar imperiyasi tarixini o‘rganish uchun muhim ilmiy-madaniy markaz hisoblanadi.

Haykal va muzey majmuasi Shahrisabzning zamonaviy ramzlaridan biriga aylangan.
    `,

                details: `
Amir Temur haykali va unga tutash muzey majmuasi shahar markazida, tarixiy obidalarga yaqin joyda barpo etilgan.

📌 Haykal haqida:
Haykal Amir Temurni taxtda o‘tirgan holatda tasvirlaydi va uning hukmdorlik qudratini ifodalaydi.

📌 Muzey ekspozitsiyasi:
- Amir Temur va Temuriylar davriga oid hujjatlar
- Davr qurollari va kiyimlari namunalari
- Temuriylar imperiyasi xaritalari
- Shahrisabz tarixiga oid arxeologik topilmalar

📌 Ahamiyati:
Muzey Shahrisabzga tashrif buyuruvchi sayyohlar uchun shahar va Amir Temur tarixi bilan yaqindan tanishish imkoniyatini beradi.

Majmua zamonaviy landshaft dizayni bilan tarixiy muhitni uyg‘unlashtirgan holda qurilgan.
    `,

                facts: [
                    "Shahrisabz markaziy maydonida joylashgan",
                    "Amir Temurning tug‘ilgan shahriga bag‘ishlangan",
                    "Haykal Temurni taxtda o‘tirgan holatda tasvirlaydi",
                    "Muzeyda Temuriylar davri hujjatlari saqlanadi",
                    "Davr qurollari va kiyimlari namunalari mavjud",
                    "Temuriylar imperiyasi xaritalari ko‘rgazmada bor",
                    "Shahrisabz arxeologik topilmalari saqlanadi",
                    "Zamonaviy landshaft dizayni bilan qurilgan",
                    "Shaharning markaziy tarixiy-madaniy maskani",
                    "Sayyohlar uchun asosiy boshlang‘ich nuqta hisoblanadi",
                    "Amir Temur hayoti haqida keng ma’lumot beradi",
                    "Ilmiy va ta’lim maqsadlarida foydalaniladi",
                    "Shahrisabzning zamonaviy ramzlaridan biri",
                    "Tarixiy obidalarga yaqin joylashgan",
                    "Har yili minglab mehmonlar tashrif buyuradi",
                    "Maktab o‘quvchilari uchun ta’limiy ekskursiyalar tashkil etiladi",
                    "Milliy g‘urur va tarix ramzi sifatida qadrlanadi",
                    "Bog‘-park hududi bilan o‘ralgan",
                    "Kechasi yoritilganda alohida go‘zallik kasb etadi",
                    "Shahrisabzga sayohatni boshlash uchun mashhur nuqta"
                ],

                images: [temur1, temur2, temur3,]
            }
        ]
    },
    ru: {
        key: "shahrisabz",

        title: "Шахрисабз — родной город Амира Темура",

        intro: `
Шахрисабз — древний город, расположенный в Кашкадарьинской долине, с историей более 2700 лет.

Этот город известен как родина Амира Темура и переводится как «Зелёный город».
    `,

        history: `
Шахрисабз — один из древнейших городов Центральной Азии, история которого уходит корнями в глубину веков. В древности город был известен под названием Кеш и являлся одним из важных центров Согдианы.
Название города происходит от персидского выражения «Шахри сабз», что означает «Зелёный город», поскольку он расположен в плодородной долине, богатой садами и зелёными насаждениями.
Главное место Шахрисабза в мировой истории связано с Амиром Темуром (1336–1405). Великий полководец родился именно в этом городе и провёл здесь своё детство. Поэтому во время своего правления Амир Темур уделял Шахрисабзу особое внимание и хотел превратить его вместе с Самаркандом в один из духовных центров своей империи.
В эпоху Амира Темура в городе велись масштабные строительные работы. Именно тогда были построены такие великие архитектурные комплексы, как Ак-Сарай, Дорус Саодат и Дорут Тиловат. По своему величию некоторые из этих сооружений превосходили даже знаменитые памятники Самарканда.
В последующие века город находился под властью различных правителей. Некоторые исторические сооружения были разрушены, однако сохранившиеся памятники до сих пор свидетельствуют о величии архитектуры эпохи Тимуридов.
Сегодня исторический центр Шахрисабза включён в список Всемирного наследия ЮНЕСКО и является одним из важнейших историко-культурных городов Узбекистана.
    `,

        sections: [
            {
                title: "Ак-Сарай — Шахрисабз",
                content: `
Ак-Сарай был построен как зимняя резиденция Амира Темура и считался одним из самых величественных и роскошных дворцов своего времени.

Это сооружение было создано как символ могущества и богатства Тимуридской империи. Его огромный портал до сих пор поражает своими масштабами.

Сегодня от дворца сохранились только остатки величественного входного портала, но даже они остаются одним из самых впечатляющих памятников Шахрисабза.
`,
                details: `
Строительство Ак-Сарая началось в 1380 году и продолжалось около 24 лет. В его создании участвовали лучшие мастера и архитекторы, привезённые из Хорезма, Ирана и Индии.

📌 Архитектурные особенности:
- Высота главного портала в первоначальном виде превышала 50 метров
- Стены были украшены голубой, белой и золотой керамической плиткой
- На фасадах использовались геометрические и растительные орнаменты
- Внутри дворца находились огромные дворы и залы для приёма гостей

📌 Историческое значение:
- Амир Темур принимал здесь иностранных послов
- Испанский посол Руй Гонсалес де Клавихо описал дворец в своих путевых заметках
- Дворец являлся символом силы и величия Тимуридов

📌 Современное состояние:
Со временем из-за разрушений и исторических событий большая часть дворца была уничтожена. До наших дней сохранились только две башни огромного входного портала, которые продолжают впечатлять своим величием.
`,
                facts: [
                    "Расположен в центре Шахрисабза",
                    "Строительство началось в 1380 году",
                    "Строительство продолжалось около 24 лет",
                    "Был зимней резиденцией Амира Темура",
                    "Название «Ак-Сарай» означает «Белый дворец»",
                    "Первоначальная высота портала превышала 50 метров",
                    "Испанский посол Клавихо описал дворец в своих записях",
                    "Сохранились только остатки входного портала",
                    "Украшен голубой и золотой керамикой",
                    "В строительстве участвовали мастера из Хорезма и Ирана",
                    "Символ могущества Тимуридской империи",
                    "Здесь принимали иностранных послов",
                    "Входит в список Всемирного наследия ЮНЕСКО",
                    "Самый известный памятник Шахрисабза",
                    "Был частично разрушен из-за времени и исторических событий",
                    "Две огромные башни сохранились до наших дней",
                    "Уникальный пример средневековой архитектуры",
                    "Одно из самых посещаемых мест туристами",
                    "Особенно впечатляюще выглядит при ночном освещении",
                    "Исторический символ Шахрисабза"
                ],
                images: [oqsaroy1, oqsaroy2, oqsaroy3,]
            },
            {
                title: "Дорут Тиловат — Шахрисабз",
                content: `
Комплекс Дорут Тиловат является одним из важнейших религиозно-исторических памятников Шахрисабза. Его название означает «место молитвы и чтения Корана».

Этот комплекс был построен в честь духовных наставников и близких людей Амира Темура и в эпоху Тимуридов являлся важным религиозным центром города.

Комплекс состоит из нескольких мавзолеев и мечетей и известен своими изысканными керамическими украшениями.
`,
                details: `
Комплекс Дорут Тиловат сформировался в конце XIV — начале XV века и включает несколько исторических сооружений.

📌 Состав комплекса:
- Мавзолей Шамсиддина Кулала — построен в честь духовного наставника Амира Темура
- Мечеть Кок Гумбаз — пятничная мечеть, построенная по приказу Улугбека
- Купольная хонако — часть комплекса, предназначенная для паломников

📌 Историческое значение:
- Шамсиддин Кулал был одним из духовных наставников Амира Темура
- Комплекс являлся священным местом для семьи Тимуридов
- Здесь проходили религиозное обучение и обряды чтения Корана

📌 Архитектура:
- Голубая и бирюзовая керамическая плитка
- Изысканные геометрические орнаменты
- Фасады, украшенные надписями
- Звездообразные узоры на куполах

На протяжении веков комплекс неоднократно реставрировался и сегодня продолжает функционировать как важное место паломничества.
`,
                facts: [
                    "Расположен в городе Шахрисабз",
                    "Название «Дорут Тиловат» означает «место чтения Корана»",
                    "Сформировался в XIV–XV веках",
                    "Включает мавзолей Шамсиддина Кулала",
                    "Мечеть Кок Гумбаз входит в состав комплекса",
                    "Духовный наставник Амира Темура похоронен здесь",
                    "Был священным местом для семьи Тимуридов",
                    "Украшен голубой и бирюзовой керамической плиткой",
                    "Имеет геометрические и растительные орнаменты",
                    "Был восстановлен в период правления Улугбека",
                    "Являлся центром религиозного образования",
                    "Сегодня остаётся действующим местом паломничества",
                    "Расположен на территории наследия ЮНЕСКО",
                    "Один из важных религиозных памятников Шахрисабза",
                    "На порталах имеются надписи из Корана",
                    "Купола украшены звездообразными узорами",
                    "Несколько раз реставрировался на протяжении веков",
                    "Считается священным местом для местных жителей",
                    "Популярное место среди туристов",
                    "Пример религиозной архитектуры эпохи Тимуридов"
                ],
                images: [dorut1, dorut2, dorut3,]
            },
            {
                title: "Дорус Саодат — Шахрисабз",
                content: `
Комплекс Дорус Саодат является одним из важнейших мавзолейных комплексов Шахрисабза. Его название означает «место счастья и благополучия».

Этот комплекс был построен Амиром Темуром после смерти его сына Джахангира как семейная усыпальница. Согласно некоторым историческим источникам, Темур также планировал построить здесь собственную гробницу.

Комплекс считается важным примером архитектуры эпохи Тимуридов благодаря своему огромному куполу и изысканным керамическим украшениям.
`,
                details: `
Строительство комплекса Дорус Саодат началось примерно в 1370–1380-х годах.

📌 Исторические сведения:
После смерти любимого сына Амира Темура — Джахангира — правитель приказал построить этот комплекс в его честь. Позже здесь были похоронены и другие представители семьи Тимуридов.

📌 Согласно легенде:
Амир Темур подготовил для себя специальную усыпальницу в этом комплексе, однако позже был похоронен в мавзолее Гур-Эмир в Самарканде.

📌 Архитектурные особенности:
- Монументальное сооружение с большим куполом
- Подземная усыпальница (крипта)
- Стены, украшенные голубой и белой керамической плиткой
- Изысканные резные мраморные элементы

📌 Современное состояние:
Большая часть комплекса со временем была разрушена, однако подземная усыпальница и некоторые элементы сохранились и продолжают изучаться археологами.
`,
                facts: [
                    "Расположен в городе Шахрисабз",
                    "Название «Дорус Саодат» означает «место счастья и благополучия»",
                    "Строительство началось в 1370–1380-х годах",
                    "Построен в честь сына Амира Темура — Джахангира",
                    "Являлся семейной усыпальницей Тимуридов",
                    "Существует легенда, что здесь была подготовлена могила для Амира Темура",
                    "Имеет подземную усыпальницу (крипту)",
                    "Украшен голубой и белой керамической плиткой",
                    "Сохранились образцы резного мрамора",
                    "Большая часть комплекса была разрушена со временем",
                    "Археологические исследования продолжаются",
                    "Пример погребальной архитектуры эпохи Тимуридов",
                    "Один из важных исторических памятников Шахрисабза",
                    "Расположен на территории наследия ЮНЕСКО",
                    "Находится рядом с Ак-Сараем",
                    "Внутренние украшения имеют геометрические орнаменты",
                    "Один из крупнейших мавзолеев эпохи Тимуридов",
                    "Часто посещается туристами",
                    "Важный источник для исторических исследований",
                    "Раскрывает важный период истории города"
                ],
                images: [dorus1, dorus2, dorus3,]
            },
            {
                title: "Мечеть Кок Гумбаз — Шахрисабз",
                content: `
Мечеть Кок Гумбаз является одной из крупнейших пятничных мечетей Шахрисабза и известна своим огромным голубым куполом.

Мечеть была построена по приказу Улугбека, входит в состав комплекса Дорут Тиловат и являлась важным центром религиозной жизни города.

Сегодня мечеть продолжает функционировать как действующий храм и остаётся важным местом для местных жителей и туристов.
`,
                details: `
Мечеть Кок Гумбаз была построена в 1430-х годах по приказу Мирзо Улугбека.

📌 Архитектурные особенности:
- Огромный голубой купол (от которого произошло название «Кок Гумбаз»)
- Большой внутренний зал для молитв
- Изысканные керамические украшения
- Геометрические и растительные орнаменты на портале

📌 Историческое значение:
- В эпоху Улугбека являлась центром науки и религии
- Как главная мечеть принимала тысячи верующих
- Является центральной частью комплекса Дорут Тиловат

📌 Современное состояние:
Мечеть неоднократно реставрировалась и сегодня сохранилась близко к своему первоначальному виду, продолжая использоваться по назначению.
`,
                facts: [
                    "Расположена в городе Шахрисабз, в комплексе Дорут Тиловат",
                    "Построена Улугбеком в 1430-х годах",
                    "Название связано с огромным голубым куполом",
                    "Выполняла функцию главной городской мечети",
                    "Имеет большой внутренний молитвенный зал",
                    "Керамические украшения выполнены в виде изысканных геометрических орнаментов",
                    "Является примером архитектуры эпохи Улугбека",
                    "До сих пор действует как мечеть",
                    "Регулярно посещается местными жителями",
                    "Центральная часть комплекса Дорут Тиловат",
                    "Несколько раз подвергалась реставрации",
                    "Расположена на территории наследия ЮНЕСКО",
                    "Важный пример религиозной архитектуры Тимуридов",
                    "На портале имеются растительные орнаменты",
                    "Была одним из центров религиозной жизни города",
                    "Часто посещается туристами",
                    "Во внутреннем интерьере сохранились декоративные надписи",
                    "По архитектуре напоминает мечети Самарканда",
                    "Один из религиозных символов Шахрисабза",
                    "Особенно красиво выглядит при ночном освещении"
                ],
                images: [kokgumbaz1, kokgumbaz2, kokgumbaz3,]
            },
            {
                title: "Купол Чорсу — Шахрисабз",

                content: `
Купол Чорсу является историческим торговым центром Шахрисабза и считался экономическим и социальным сердцем города.

Это сооружение представляет собой торговый купол, построенный на пересечении четырёх дорог, который на протяжении веков служил главным местом для ремесленников и торговцев.

Сегодня Купол Чорсу продолжает функционировать как исторический рынок и является интересным местом для туристов.
`,

                details: `
Купол Чорсу расположен в центре города, на пересечении четырёх основных улиц. Слово «чорсу» означает «четыре дороги».

📌 Историческое значение:
- Был центром торговли и ремесленного производства
- Служил частью местного торгового маршрута Великого Шёлкового пути
- Здесь продавались различные товары — ткани, керамические изделия и металлические предметы

📌 Архитектура:
- Закрытая торговая галерея с купольной конструкцией
- Специальные отверстия для вентиляции и естественного освещения
- Простая, но практичная архитектура

📌 Современное состояние:
Сегодня Купол Чорсу продолжает работать как традиционный рынок, где местные мастера продают свои изделия.
`,

                facts: [
                    "Расположен в центре города Шахрисабз",
                    "Слово «Чорсу» означает «четыре дороги»",
                    "Построен на пересечении четырёх главных улиц",
                    "Был историческим центром торговли и ремесел",
                    "Являлся частью местной сети Великого Шёлкового пути",
                    "Имеет закрытую купольную структуру рынка",
                    "Оснащён специальными отверстиями для вентиляции",
                    "Сегодня продолжает работать как действующий рынок",
                    "Местные ремесленники продают здесь свои изделия",
                    "Был центром экономической и социальной жизни города",
                    "Сохраняет торговые традиции со времён Тимуридов",
                    "Туристы могут познакомиться здесь с местными ремёслами",
                    "Расположен недалеко от Ак-Сарая и Дорус Саодат",
                    "Является важной частью исторического центра города",
                    "Соединяет современную жизнь с историческим наследием",
                    "Здесь можно найти национальные блюда и сувениры",
                    "Архитектура проста, но функциональна",
                    "Находится в зоне исторического наследия ЮНЕСКО",
                    "Один из живых исторических объектов Шахрисабза",
                    "Ежедневно используется местными жителями"
                ],

                images: [chorsu1, chorsu2, chorsu3,]
            },
            {
                title: "Статуя Амира Темура и музей — Шахрисабз",

                content: `
Статуя Амира Темура и музей расположены на центральной площади Шахрисабза и являются главным памятным комплексом, посвящённым великому полководцу в городе его рождения.

Это место считается важным научным и культурным центром для изучения жизни Амира Темура, его деятельности и истории империи Тимуридов.

Комплекс статуи и музея стал одним из современных символов Шахрисабза.
`,

                details: `
Статуя Амира Темура и прилегающий музейный комплекс находятся в центре города, рядом с историческими памятниками Шахрисабза.

📌 О статуе:
Статуя изображает Амира Темура сидящим на троне и символизирует его могущество как правителя и основателя великой державы.

📌 Экспозиция музея:
- Исторические документы, связанные с Амиром Темуром и эпохой Тимуридов
- Образцы оружия и одежды того периода
- Карты империи Тимуридов
- Археологические находки, связанные с историей Шахрисабза

📌 Значение:
Музей позволяет туристам глубже познакомиться с историей города и жизнью Амира Темура.

Комплекс создан с современным ландшафтным дизайном, гармонично сочетая историческую атмосферу и современное городское пространство.
`,

                facts: [
                    "Расположен на центральной площади Шахрисабза",
                    "Посвящён месту рождения Амира Темура",
                    "Статуя изображает Темура сидящим на троне",
                    "В музее хранятся документы эпохи Тимуридов",
                    "Представлены образцы оружия и одежды того периода",
                    "В экспозиции имеются карты империи Тимуридов",
                    "Хранятся археологические находки Шахрисабза",
                    "Создан с современным ландшафтным дизайном",
                    "Является центральным историко-культурным местом города",
                    "Считается отправной точкой для туристов",
                    "Предоставляет подробную информацию о жизни Амира Темура",
                    "Используется в научных и образовательных целях",
                    "Один из современных символов Шахрисабза",
                    "Расположен рядом с историческими памятниками",
                    "Ежегодно посещается тысячами туристов",
                    "Для школьников организуются образовательные экскурсии",
                    "Считается символом национальной гордости и истории",
                    "Окружён парковыми зонами",
                    "Особенно красиво выглядит при вечернем освещении",
                    "Популярное место для начала путешествия по Шахрисабзу"
                ],

                images: [temur1, temur2, temur3,]
            },
        ]
    },


    en: {
        key: "shahrisabz",
        title: "Shahrisabz — The birthplace of Amir Temur",

        intro: `
Shahrisabz is an ancient city located in the Kashkadarya valley with more than 2700 years of history.
The city is famous as the birthplace of Amir Temur and its name means "Green City".
`,

        history: `
Shahrisabz is one of the oldest cities of Central Asia, with a history dating back to ancient times. In the past, the city was known as Kesh and was one of the important centers of Sogdiana.

The name Shahrisabz comes from the Persian words "Shahri Sabz", meaning "Green City", because the city was located in a fertile valley rich in gardens and greenery.

The most important period in the history of Shahrisabz is connected with Amir Temur (1336–1405). The great commander was born here and spent his childhood in this city. Because of this, Amir Temur gave special importance to Shahrisabz and wanted to make it one of the spiritual capitals of his empire alongside Samarkand.

During the Timurid era, large construction projects were carried out in the city. Famous monuments such as Oqsaroy, Dorut Tilovat, and Dorus Saodat were built during this period. These structures were among the greatest architectural achievements of their time.

In later centuries, the city was ruled by different dynasties, and some historical monuments were damaged. However, the remaining buildings still demonstrate the greatness of Timurid architecture.

Today, the historical center of Shahrisabz is included in the UNESCO World Heritage List and is considered one of the most important historical and cultural cities of Uzbekistan.
`,

        sections: [
            {
                title: "Oqsaroy — Shahrisabz",
                content: `
Oqsaroy was built as Amir Temur’s winter residence and was considered one of the largest and most magnificent palaces of its time.

This monument was constructed to demonstrate the power and wealth of the Timurid Empire, and its massive entrance portal continues to amaze visitors with its impressive size.

Although only the remains of the grand entrance portal have survived today, Oqsaroy remains one of the most remarkable historical monuments of Shahrisabz.
`,
                details: `
The construction of Oqsaroy began in 1380 and lasted for approximately 24 years. The best architects and craftsmen from Khorezm, Iran, and India participated in its construction.

📌 Architectural features:
- The original entrance portal was more than 50 meters high
- The walls were decorated with blue, white, and golden ceramic tiles
- Geometric and Islamic ornamental patterns covered the façade
- The palace included large courtyards and reception halls

📌 Historical importance:
- Amir Temur received foreign ambassadors here
- Spanish ambassador Ruy González de Clavijo described the palace in his travel writings
- The palace became a symbol of the power and greatness of the Timurid Empire

📌 Current condition:
Over time, wars and historical events destroyed most of the palace. Today, only the remains of the huge entrance portal have survived, but they still preserve their impressive grandeur.
`,
                facts: [
                    "Located in the center of Shahrisabz",
                    "Construction began in 1380",
                    "The construction lasted approximately 24 years",
                    "Was Amir Temur’s winter residence",
                    "The name Oqsaroy means \"White Palace\"",
                    "The original entrance portal was estimated to be over 50 meters high",
                    "Described by Spanish ambassador Ruy González de Clavijo",
                    "Only the remains of the entrance portal have survived",
                    "Decorated with blue and golden ceramic tiles",
                    "Architects from Khorezm and Iran participated in construction",
                    "Was a symbol of Timurid power",
                    "Foreign ambassadors were welcomed here",
                    "Included in the UNESCO World Heritage area",
                    "The most famous monument of Shahrisabz",
                    "Partially destroyed by time and historical events",
                    "Two massive towers of the portal have survived",
                    "A unique example of medieval architecture",
                    "One of the most visited places by tourists",
                    "Looks especially impressive when illuminated at night",
                    "A historical symbol of Shahrisabz"
                ],
                images: [oqsaroy1, oqsaroy2, oqsaroy3,]
            },
            {
                title: "Dorut Tilovat Complex — Shahrisabz",
                content: `
The Dorut Tilovat Complex is one of the most important religious and historical monuments of Shahrisabz. Its name means "Place of Recitation".

The complex was built in honor of Amir Temur’s spiritual mentors and close relatives and became an important religious center of the city during the Timurid period.

The complex consists of several mausoleums and mosques and is famous for its elegant ceramic decorations.
`,
                details: `
The Dorut Tilovat Complex was formed in the late 14th and early 15th centuries and includes several historical buildings.

📌 Components of the complex:
- Shamsiddin Kulol Mausoleum — built in honor of Amir Temur’s spiritual mentor
- Kok Gumbaz Mosque — a Friday mosque built by Ulugbek
- Domed khanqah — a part of the complex designed for visitors and pilgrims

📌 Historical importance:
- Shamsiddin Kulol was one of Amir Temur’s spiritual teachers
- The complex was a sacred place for the Timurid family
- Religious education and Quran recitation ceremonies were held here

📌 Architecture:
- Blue and turquoise ceramic tiles
- Elegant geometric patterns
- Portals decorated with inscriptions
- Star-shaped designs on the domes

The complex has been restored several times throughout history and continues to function as an important religious pilgrimage site today.
`,
                facts: [
                    "Located in the city of Shahrisabz",
                    "The name Dorut Tilovat means \"Place of Recitation\"",
                    "Formed during the 14th–15th centuries",
                    "Includes the Mausoleum of Shamsiddin Kulol",
                    "Kok Gumbaz Mosque is part of the complex",
                    "Amir Temur’s spiritual mentor is buried here",
                    "Was a sacred pilgrimage site for the Timurid family",
                    "Decorated with blue and turquoise ceramic tiles",
                    "Contains geometric and Islamic ornamental patterns",
                    "Was rebuilt during the era of Ulugbek",
                    "Served as a center of religious education",
                    "Still functions as a pilgrimage site today",
                    "Located within the UNESCO heritage area",
                    "One of the important religious monuments of Shahrisabz",
                    "Portals contain Quranic inscriptions",
                    "Domes are decorated with star-shaped patterns",
                    "Restored several times over the centuries",
                    "Considered a sacred place by local people",
                    "A popular destination among tourists",
                    "An example of Timurid religious architecture"
                ],
                images: [dorut1, dorut2, dorut3,]
            },
            {
                title: "Dorus Saodat Complex — Shahrisabz",
                content: `
The Dorus Saodat Complex is one of the most important mausoleum complexes in Shahrisabz. Its name means "Place of Happiness and Prosperity".

The complex was built by Amir Temur after the death of his son Jahongir as a family mausoleum. According to some historical sources, Amir Temur also planned to build his own tomb here.

With its massive dome and elegant ceramic decorations, the complex is considered an important example of Timurid architecture.
`,
                details: `
The construction of the Dorus Saodat Complex began around 1370–1380.

📌 Historical information:
After the death of Amir Temur’s beloved son Jahongir, Temur ordered the construction of this complex in his honor. Later, other members of the Timurid family were also buried here.

📌 According to legend:
Amir Temur prepared a special burial place for himself in this complex, but later he was buried in the Gur-e Amir Mausoleum in Samarkand.

📌 Architectural features:
- A monumental structure with a large dome
- An underground burial chamber (crypt)
- Walls decorated with blue and white ceramic tiles
- Fine carved marble details

📌 Current condition:
Most of the complex was destroyed over time, but the underground crypt and some remaining parts have survived and continue to be studied by archaeologists.
`,
                facts: [
                    "Located in the city of Shahrisabz",
                    "The name Dorus Saodat means \"Place of Happiness and Prosperity\"",
                    "Construction began around 1370–1380",
                    "Built in honor of Amir Temur’s son Jahongir",
                    "Served as the family mausoleum of the Timurids",
                    "According to legend, Amir Temur prepared his own tomb here",
                    "Contains an underground burial chamber (crypt)",
                    "Decorated with blue and white ceramic tiles",
                    "Contains examples of carved marble decoration",
                    "Most of the complex was destroyed over time",
                    "Archaeological studies are still being carried out",
                    "An example of Timurid funerary architecture",
                    "One of the important historical monuments of Shahrisabz",
                    "Located within the UNESCO heritage area",
                    "Situated near Oqsaroy",
                    "Interior decorations include geometric patterns",
                    "One of the largest mausoleum complexes of the Timurid era",
                    "Frequently visited by tourists",
                    "An important source for historical research",
                    "Reveals an important layer of the city’s history"
                ],
                images: [dorus1, dorus2, dorus3,]
            },
            {
                title: "Kok Gumbaz Mosque — Shahrisabz",

                content: `
Kok Gumbaz Mosque is one of the largest Friday mosques in Shahrisabz and is famous for its magnificent blue dome.

The mosque was built by Ulugbek and is part of the Dorut Tilovat Complex. It served as an important center of religious life in the city.

Today, the mosque continues to function as an active place of worship and remains an important site for both local residents and tourists.
`,

                details: `
Kok Gumbaz Mosque was built in the 1430s by the order of Mirzo Ulugbek.

📌 Architectural features:
- A large blue dome, from which the mosque received its name "Kok Gumbaz"
- A spacious interior prayer hall
- Elegant ceramic tile decorations
- Geometric and floral patterns on the entrance portal

📌 Historical importance:
- Served as a center of religion and education during the era of Ulugbek
- Functioned as the main Friday mosque and welcomed thousands of worshippers
- Represents the central part of the Dorut Tilovat Complex

📌 Current condition:
The mosque has been restored several times and has preserved its original appearance. Today, it continues to be used as an active mosque.
`,

                facts: [
                    "Located in Shahrisabz, within the Dorut Tilovat Complex",
                    "Built by Ulugbek in the 1430s",
                    "Its name comes from the large blue dome",
                    "Served as the main Friday mosque of the city",
                    "Has a large interior prayer hall",
                    "Decorated with elegant geometric ceramic patterns",
                    "An example of Ulugbek-era architecture",
                    "Still functions as an active mosque today",
                    "Regularly visited by local residents",
                    "The central part of the Dorut Tilovat Complex",
                    "Restored several times throughout history",
                    "Located within the UNESCO heritage area",
                    "An important example of Timurid religious architecture",
                    "The entrance portal contains floral ornaments",
                    "Was one of the centers of religious life in the city",
                    "Frequently visited by tourists",
                    "Decorative inscriptions are preserved inside",
                    "Architecturally similar to some mosques of Samarkand",
                    "One of the religious symbols of Shahrisabz",
                    "Looks especially beautiful when illuminated at night"
                ],

                images: [kokgumbaz1, kokgumbaz2, kokgumbaz3,]
            },
            {
                title: "Chorsu Dome — Shahrisabz",

                content: `
The Chorsu Dome is a historical trading center of Shahrisabz and was considered the economic and social heart of the city.

This building is a domed marketplace constructed at the intersection of four roads and served as the main place for merchants and craftsmen for centuries.

Today, the Chorsu Dome continues to function as a historical market and has become an interesting destination for tourists.
`,

                details: `
The Chorsu Dome was built in the center of the city, at the intersection of four main streets. The word "Chorsu" means "four roads".

📌 Historical function:
- Served as a center of trade and craftsmanship
- Was part of the local branch of the Great Silk Road
- Various goods such as fabrics, ceramics, and metal products were sold here

📌 Architecture:
- A closed trading gallery with a domed structure
- Special openings for ventilation and natural lighting
- A simple but practical construction style

📌 Current condition:
Today, the Chorsu Dome continues to operate as a traditional market where local craftsmen sell their handmade products.
`,

                facts: [
                    "Located in the center of Shahrisabz",
                    "The word \"Chorsu\" means \"four roads\"",
                    "Built at the intersection of four main streets",
                    "Was a historical center of trade and crafts",
                    "Was part of the local Great Silk Road network",
                    "Has a closed domed market structure",
                    "Contains special ventilation openings",
                    "Still functions as an active market today",
                    "Local craftsmen sell their products here",
                    "Was the center of the city’s economic and social life",
                    "Has preserved trading traditions since the Timurid era",
                    "Allows tourists to experience local crafts",
                    "Located near Oqsaroy and Dorus Saodat",
                    "An important part of the historical center of Shahrisabz",
                    "Connects modern life with historical heritage",
                    "Traditional food and souvenirs can be found here",
                    "Its architecture is simple but functional",
                    "Located within the historical UNESCO heritage area",
                    "One of the living historical places of Shahrisabz",
                    "Used daily by local residents"
                ],

                images: [chorsu1, chorsu2, chorsu3,]
            },
            {
                title: "Amir Temur Statue and Museum — Shahrisabz",

                content: `
The Amir Temur Statue and Museum is located in the central square of Shahrisabz and is one of the main monuments dedicated to the great commander in his birthplace.

This place is an important cultural and educational center for learning about Amir Temur’s life, achievements, and the history of the Timurid Empire.

The statue and museum complex has become one of the modern symbols of Shahrisabz.
`,

                details: `
The Amir Temur statue and the connected museum complex were built in the city center, close to the main historical monuments of Shahrisabz.

📌 About the statue:
The statue depicts Amir Temur sitting on a throne and represents his power, authority, and leadership.

📌 Museum exhibition:
- Historical documents related to Amir Temur and the Timurids
- Examples of weapons and traditional clothing from the period
- Maps of the Timurid Empire
- Archaeological discoveries related to the history of Shahrisabz

📌 Importance:
The museum provides visitors with an opportunity to learn more about the history of Shahrisabz and the life of Amir Temur.

The complex combines modern landscape design with the historical atmosphere of the city.
`,

                facts: [
                    "Located in the central square of Shahrisabz",
                    "Dedicated to Amir Temur’s birthplace",
                    "The statue depicts Amir Temur sitting on a throne",
                    "The museum preserves documents from the Timurid era",
                    "Contains examples of weapons and clothing from the period",
                    "Maps of the Timurid Empire are displayed",
                    "Archaeological discoveries of Shahrisabz are preserved here",
                    "Built with modern landscape design",
                    "A central historical and cultural site of the city",
                    "A popular starting point for tourists visiting Shahrisabz",
                    "Provides detailed information about Amir Temur’s life",
                    "Used for educational and scientific purposes",
                    "One of the modern symbols of Shahrisabz",
                    "Located near historical monuments",
                    "Thousands of visitors come here every year",
                    "Educational tours are organized for students",
                    "Considered a symbol of national pride and history",
                    "Surrounded by a park area",
                    "Looks especially beautiful when illuminated at night",
                    "A famous place to begin exploring Shahrisabz"
                ],

                images: [temur1, temur2, temur3,]
            }
        ]
    },

    fr: {
        key: "shahrisabz",
        title: "Shahrisabz — La ville natale d’Amir Timour",

        intro: `
Shahrisabz est une ancienne ville située dans la vallée de Qashqadaryo, avec plus de 2700 ans d’histoire.
Cette ville est célèbre comme le lieu de naissance d’Amir Timour et son nom signifie « La ville verte ».
`,

        history: `
Shahrisabz est l’une des plus anciennes villes d’Asie centrale, avec une histoire qui remonte à l’Antiquité. Dans le passé, la ville était connue sous le nom de Kesh et était un centre important de la région de Sogdiane.

Le nom Shahrisabz vient du persan « Shahri Sabz », qui signifie « Ville verte », en raison de ses terres fertiles, de ses jardins et de sa végétation abondante.

L’histoire mondiale de Shahrisabz est principalement liée à Amir Timour (1336–1405). Le grand chef militaire est né dans cette ville et y a passé sa jeunesse. Pendant son règne, il souhaitait transformer Shahrisabz en un important centre spirituel de son empire, au même niveau que Samarcande.

À l’époque d’Amir Timour, de grands projets de construction furent réalisés. Le palais Ak-Saray, le complexe Dorus Saodat et le complexe Dorut Tilovat furent construits durant cette période et témoignent encore aujourd’hui de la grandeur de l’architecture timouride.

Au cours des siècles suivants, la ville passa sous le contrôle de différents dirigeants. Certains monuments furent détruits, mais les bâtiments restants montrent encore la richesse de l’architecture de l’époque des Timourides.

Aujourd’hui, le centre historique de Shahrisabz est inscrit au patrimoine mondial de l’UNESCO et représente l’une des villes historiques et culturelles les plus importantes d’Ouzbékistan.
`,

        sections: [
            {
                title: "Ak-Saray — Shahrisabz",

                content: `
Ak-Saray était le palais d’hiver d’Amir Timour et l’un des palais les plus grands et les plus luxueux de son époque.

Construit pour montrer la puissance et la richesse de l’Empire timouride, ce monument impressionne encore aujourd’hui par la grandeur de son portail monumental.

Même si seuls les vestiges du portail ont été conservés, Ak-Saray reste l’un des monuments les plus remarquables de Shahrisabz.
`,

                details: `
La construction d’Ak-Saray a commencé en 1380 et a duré environ 24 ans. Les meilleurs architectes et artisans venus de Khorezm, d’Iran et d’Inde ont participé à sa construction.

📌 Caractéristiques architecturales:
- Un portail dont la hauteur dépassait autrefois 50 mètres
- Des décorations en mosaïque bleue, blanche et dorée
- Des motifs géométriques et végétaux raffinés
- De grandes cours et salles de réception à l’intérieur du palais

📌 Importance historique:
- Amir Timour y recevait des ambassadeurs étrangers
- L’ambassadeur espagnol Rui Gonzalez de Clavijo a décrit le palais dans son récit de voyage
- Le palais représentait la puissance et la grandeur des Timourides

📌 État actuel:
Avec le temps et les différentes destructions, une grande partie du palais a disparu. Seuls les vestiges du portail monumental sont encore conservés, mais ils témoignent toujours de sa splendeur passée.
`,

                facts: [
                    "Situé au centre de Shahrisabz",
                    "La construction a commencé en 1380",
                    "Les travaux ont duré environ 24 ans",
                    "Résidence d’Amir Timour",
                    "Le nom signifie « Palais blanc »",
                    "Le portail original dépassait probablement 50 mètres de hauteur",
                    "Décrit par l’ambassadeur espagnol Rui Gonzalez de Clavijo",
                    "Seuls les vestiges du portail sont conservés",
                    "Décoré avec des mosaïques bleues, blanches et dorées",
                    "Des artisans de Khorezm, d’Iran et d’Inde ont participé à sa construction",
                    "Symbole de la puissance de l’Empire timouride",
                    "Lieu où les ambassadeurs étrangers étaient reçus",
                    "Inscrit dans la zone du patrimoine mondial de l’UNESCO",
                    "L’un des monuments les plus célèbres de Shahrisabz",
                    "Partiellement détruit par le temps et les invasions",
                    "Exemple exceptionnel de l’architecture médiévale",
                    "Un des lieux les plus visités par les touristes",
                    "Très impressionnant lorsqu’il est illuminé la nuit",
                    "Symbole historique de Shahrisabz",
                    "Témoignage de la grandeur des Timourides"
                ],

                images: [oqsaroy1, oqsaroy2, oqsaroy3,]
            },
            {
                title: "Complexe Dorut Tilovat — Shahrisabz",

                content: `
Le complexe Dorut Tilovat est l’un des monuments religieux et historiques les plus importants de Shahrisabz. Son nom signifie « lieu de récitation et de prière ».

Ce complexe a été construit en l’honneur des maîtres spirituels et des proches d’Amir Timour. À l’époque des Timourides, il représentait le centre religieux de la ville.

Le complexe se compose de plusieurs mausolées et mosquées et il est célèbre pour ses magnifiques décorations en céramique et ses détails architecturaux raffinés.
`,

                details: `
Le complexe Dorut Tilovat s’est formé à la fin du XIVe siècle et au début du XVe siècle. Il comprend plusieurs monuments historiques importants.

📌 Composition du complexe:
- Le mausolée de Shamsiddin Kulol — construit en l’honneur du maître spirituel d’Amir Timour
- La mosquée Kok Gumbaz — grande mosquée construite sous le règne d’Ulugbek
- Un khanqah avec une salle à coupole destinée aux pèlerins

📌 Importance historique:
- Shamsiddin Kulol était l’un des guides spirituels d’Amir Timour
- Le complexe était un lieu sacré pour la famille timouride
- Des cérémonies religieuses et des activités d’enseignement y étaient organisées

📌 Architecture:
- Décorations en carreaux bleus et turquoise
- Motifs géométriques et islamiques raffinés
- Portails décorés d’inscriptions
- Coupoles ornées de motifs en forme d’étoiles

Le complexe a été restauré plusieurs fois au cours des siècles. Aujourd’hui, il reste un lieu de pèlerinage important et un monument historique majeur.
`,

                facts: [
                    "Situé dans la ville de Shahrisabz",
                    "Dorut Tilovat signifie « lieu de récitation »",
                    "Formé aux XIVe–XVe siècles",
                    "Comprend le mausolée de Shamsiddin Kulol",
                    "La mosquée Kok Gumbaz fait partie du complexe",
                    "Le maître spirituel d’Amir Timour y est enterré",
                    "Lieu sacré pour la famille timouride",
                    "Décoré avec des carreaux bleus et turquoise",
                    "Présente des motifs géométriques et islamiques",
                    "Restauré pendant la période d’Ulugbek",
                    "Ancien centre d’enseignement religieux",
                    "Aujourd’hui encore un lieu de pèlerinage actif",
                    "Situé dans la zone du patrimoine de l’UNESCO",
                    "L’un des monuments religieux importants de Shahrisabz",
                    "Les portails sont décorés d’inscriptions coraniques",
                    "Les coupoles possèdent des décorations en forme d’étoiles",
                    "Restauré plusieurs fois au cours de son histoire",
                    "Considéré comme un lieu sacré par la population locale",
                    "Très apprécié des touristes",
                    "Un exemple remarquable de l’architecture religieuse timouride"
                ],

                images: [dorut1, dorut2, dorut3,]
            },
            {
                title: "Complexe Dorus Saodat — Shahrisabz",

                content: `
Le complexe Dorus Saodat est l’un des ensembles funéraires les plus importants de Shahrisabz. Son nom signifie « lieu du bonheur éternel ».

Ce complexe a été construit par Amir Timour après la mort de son fils Jahongir comme mausolée familial. Selon certaines sources historiques, Timour avait également prévu d’y être enterré lui-même.

Avec son immense coupole et ses magnifiques décorations en céramique, Dorus Saodat représente un exemple remarquable de l’architecture de l’époque timouride.
`,

                details: `
La construction du complexe Dorus Saodat a commencé vers 1370–1380.

📌 Informations historiques:
Après la mort de Jahongir, le fils bien-aimé d’Amir Timour, le souverain fit construire ce complexe en son honneur. Plus tard, d’autres membres de la famille timouride y furent également enterrés.

📌 Selon la légende:
Amir Timour aurait fait préparer son propre tombeau dans ce complexe, mais il fut finalement enterré à Samarcande, dans le mausolée Gour Emir.

📌 Caractéristiques architecturales:
- Structure avec une grande coupole
- Crypte souterraine
- Murs décorés de carreaux bleus et blancs
- Éléments décoratifs en marbre sculpté

📌 État actuel:
Une grande partie du complexe a été détruite avec le temps, mais la crypte souterraine et certains éléments ont été conservés et continuent d’être étudiés par les archéologues.
`,

                facts: [
                    "Situé dans la ville de Shahrisabz",
                    "Dorus Saodat signifie « lieu du bonheur éternel »",
                    "La construction a commencé vers 1370–1380",
                    "Construit en l’honneur de Jahongir, le fils d’Amir Timour",
                    "Servait de mausolée familial aux Timourides",
                    "Une légende raconte que Timour voulait y être enterré",
                    "Possède une crypte souterraine",
                    "Décoré avec des carreaux bleus et blancs",
                    "Des éléments en marbre sculpté sont conservés",
                    "Une grande partie du complexe a disparu avec le temps",
                    "Des recherches archéologiques y sont menées",
                    "Exemple important de l’architecture funéraire timouride",
                    "Monument historique majeur de Shahrisabz",
                    "Situé dans une zone inscrite au patrimoine de l’UNESCO",
                    "Se trouve près du palais Ak-Saray",
                    "Présente des motifs géométriques dans ses décorations",
                    "L’un des plus grands mausolées construits sous les Timourides",
                    "Souvent visité par les touristes",
                    "Source importante pour les historiens",
                    "Révèle une partie importante de l’histoire de Shahrisabz"
                ],

                images: [dorus1, dorus2, dorus3,]
            },
            {
                title: "Mosquée Kok Gumbaz — Shahrisabz",

                content: `
La mosquée Kok Gumbaz est l’une des plus grandes mosquées de Shahrisabz. Elle est célèbre pour son immense coupole bleue qui lui a donné son nom.

La mosquée a été construite sur ordre d’Ulugbek et fait partie du complexe Dorut Tilovat. Pendant l’époque timouride, elle était l’un des principaux centres religieux de la ville.

Aujourd’hui, la mosquée reste un lieu de culte actif et un monument important pour les habitants et les visiteurs de Shahrisabz.
`,

                details: `
La mosquée Kok Gumbaz a été construite dans les années 1430 sur ordre de Mirzo Ulugbek.

📌 Caractéristiques architecturales:
- Grande coupole bleue (d’où vient le nom « Kok Gumbaz »)
- Grande salle intérieure de prière
- Décorations raffinées en céramique
- Portail décoré de motifs géométriques et végétaux

📌 Importance historique:
- Elle était un centre religieux et scientifique à l’époque d’Ulugbek
- En tant que mosquée du vendredi, elle accueillait de nombreux fidèles
- Elle représente la partie centrale du complexe Dorut Tilovat

📌 État actuel:
La mosquée a été restaurée plusieurs fois au cours de son histoire. Aujourd’hui, elle conserve son aspect historique et continue d’être utilisée comme lieu de prière.
`,

                facts: [
                    "Située à Shahrisabz dans le complexe Dorut Tilovat",
                    "Construite dans les années 1430 par Ulugbek",
                    "Son nom vient de son immense coupole bleue",
                    "Servait de mosquée principale de la ville",
                    "Possède une grande salle intérieure de prière",
                    "Décorée avec de magnifiques motifs géométriques",
                    "Exemple de l’architecture de l’époque d’Ulugbek",
                    "Encore utilisée aujourd’hui comme mosquée",
                    "Régulièrement visitée par les habitants",
                    "Partie centrale du complexe Dorut Tilovat",
                    "Restaurée plusieurs fois au cours des siècles",
                    "Située dans une zone du patrimoine de l’UNESCO",
                    "Exemple important de l’architecture religieuse timouride",
                    "Son portail contient des motifs végétaux décoratifs",
                    "A joué un rôle important dans la vie religieuse de la ville",
                    "Très appréciée par les visiteurs",
                    "Son intérieur conserve des éléments décoratifs historiques",
                    "Présente une architecture proche des mosquées de Samarcande",
                    "L’un des symboles religieux de Shahrisabz",
                    "Particulièrement impressionnante lorsqu’elle est éclairée la nuit"
                ],

                images: [kokgumbaz1, kokgumbaz2, kokgumbaz3,]
            },
            {
                title: "Coupole Chorsu — Shahrisabz",

                content: `
La coupole Chorsu est un ancien centre commercial historique de Shahrisabz et représentait le cœur économique et social de la ville.

Cette construction en forme de dôme se trouvait au croisement de quatre routes et servait pendant des siècles de lieu principal pour les commerçants et les artisans.

Aujourd’hui, la coupole Chorsu conserve son rôle de marché historique et représente un lieu intéressant pour les visiteurs souhaitant découvrir la vie traditionnelle de Shahrisabz.
`,

                details: `
La coupole Chorsu est située au centre de la ville, à l’intersection de quatre grandes rues. Le mot « Chorsu » signifie « quatre chemins ».

📌 Fonction historique:
- Centre du commerce et de l’artisanat
- Lieu important sur les routes commerciales locales liées à la Route de la Soie
- Vente de différents produits comme les tissus, les objets en céramique et les produits métalliques

📌 Architecture:
- Galerie commerciale fermée avec une grande coupole
- Ouvertures spéciales pour la ventilation et l’éclairage naturel
- Style architectural simple mais très fonctionnel

📌 État actuel:
Aujourd’hui, la coupole Chorsu continue de fonctionner comme un marché traditionnel où les artisans locaux présentent leurs produits et leurs créations.
`,

                facts: [
                    "Située au centre historique de Shahrisabz",
                    "Le mot « Chorsu » signifie « quatre chemins »",
                    "Construite à l’intersection de quatre routes principales",
                    "Ancien centre du commerce et de l’artisanat",
                    "Liée aux traditions commerciales de la Route de la Soie",
                    "Possède une structure avec une grande coupole fermée",
                    "Dispose d’ouvertures pour la ventilation",
                    "Fonctionne encore aujourd’hui comme marché",
                    "Les artisans locaux y vendent leurs produits",
                    "Centre important de la vie économique et sociale de la ville",
                    "Conserve les traditions commerciales depuis l’époque timouride",
                    "Permet aux touristes de découvrir l’artisanat local",
                    "Située près d’Ak-Saray et de Dorus Saodat",
                    "Partie importante du centre historique de Shahrisabz",
                    "Un lieu où l’histoire rencontre la vie quotidienne",
                    "On peut y trouver des produits locaux et des souvenirs",
                    "Son architecture est simple mais pratique",
                    "Un des lieux historiques vivants de Shahrisabz",
                    "Fréquentée chaque jour par les habitants",
                    "Un exemple du patrimoine commercial traditionnel"
                ],

                images: [chorsu1, chorsu2, chorsu3,]
            },
            {
                title: "Statue et musée d’Amir Timour — Shahrisabz",

                content: `
La statue et le musée d’Amir Timour sont situés sur la place centrale de Shahrisabz et constituent l’un des principaux monuments dédiés au grand commandant dans sa ville natale.

Ce lieu représente un centre culturel et éducatif important consacré à la vie d’Amir Timour, à ses réalisations et à l’histoire de l’Empire timouride.

L’ensemble de la statue et du musée est devenu l’un des symboles modernes de Shahrisabz.
`,

                details: `
La statue d’Amir Timour et le complexe du musée ont été construits au centre de la ville, à proximité des principaux monuments historiques de Shahrisabz.

📌 À propos de la statue:
La statue représente Amir Timour assis sur un trône et symbolise sa puissance, son autorité et son rôle de grand dirigeant.

📌 Exposition du musée:
- Documents historiques liés à Amir Timour et aux Timourides
- Exemples d’armes et de vêtements de l’époque
- Cartes de l’Empire timouride
- Découvertes archéologiques liées à l’histoire de Shahrisabz

📌 Importance:
Le musée permet aux visiteurs de mieux connaître l’histoire de Shahrisabz et la vie du grand conquérant Amir Timour.

Le complexe associe un aménagement paysager moderne à l’atmosphère historique de la ville.
`,

                facts: [
                    "Situé sur la place centrale de Shahrisabz",
                    "Dédié à la ville natale d’Amir Timour",
                    "La statue représente Amir Timour assis sur un trône",
                    "Le musée conserve des documents de l’époque timouride",
                    "Des armes et vêtements historiques y sont exposés",
                    "Des cartes de l’Empire timouride sont présentées",
                    "Des découvertes archéologiques de Shahrisabz y sont conservées",
                    "Construit avec un aménagement paysager moderne",
                    "Un centre historique et culturel important de la ville",
                    "Un point de départ populaire pour les touristes",
                    "Présente l’histoire de la vie d’Amir Timour",
                    "Utilisé à des fins éducatives et scientifiques",
                    "L’un des symboles modernes de Shahrisabz",
                    "Situé près des monuments historiques principaux",
                    "Accueille chaque année de nombreux visiteurs",
                    "Des visites éducatives sont organisées pour les élèves",
                    "Symbole de fierté nationale et historique",
                    "Entouré d’un espace vert et d’un parc",
                    "Très beau lorsqu’il est illuminé la nuit",
                    "Un lieu célèbre pour commencer la découverte de Shahrisabz"
                ],

                images: [temur1, temur2, temur3,]
            }
        ]
    }










};

export default shahrisabz;